<template>
    <div class="body_main">
        <div class="body_bd">
            <!-- 搜索-->
            <el-form class="search_con" :model="queryParams" ref="queryForm" :inline="true" label-width="68px">
                <el-form-item label="姓名" prop="articleTitle">
                    <el-input
                        v-model="queryParams.cardPatientName"
                        placeholder="请输入预约人姓名"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="身份证" prop="articleTitle">
                    <el-input
                        v-model="queryParams.cardIdentity"
                        placeholder="请输入预约人身份证"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="手机号" prop="articleTitle">
                    <el-input
                        v-model="queryParams.cardPatientPhone"
                        placeholder="请输入预约人手机号码"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="状态">
                    <el-select placeholder="请选择预约单状态" v-model="queryParams.reStatusMiniDoc"
                               style="width: 200px" @change="chooseStatus()">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="待就诊" value="1"></el-option>
                        <el-option label="历史预约单" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="预约时间">
                    <el-date-picker
                        v-model="dateTime"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="YYYY-MM-DD"
                        @change="chooseDateTime"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="Search" @click="getReservationListInfo()">搜索</el-button>
                    <el-button icon="Refresh" @click="resetQuery">重置</el-button>
                </el-form-item>
            </el-form>

            <!-- 表格-->
            <div class="table_bd">
                <el-table
                    ref="multipleTable"
                    v-loading="tableLoading"
                    :data="tableData"
                    :max-height="tableHeight"
                    style="width: 100%">
                    <template #empty>
                        <el-empty :image-size="120"></el-empty>
                    </template>
                    <el-table-column type="index" label="序号" width="50"> </el-table-column>
                    <el-table-column
                        prop="reSerialNo"
                        label="预约单号">
                    </el-table-column>
                    <el-table-column
                        label="预约人">
                        <template #default="scope">
                            <div class="base_con">
                                <el-image class="elImage" :src="scope.row.avatar"></el-image>
                                <div class="base_info">
                                    <span style="font-size: 16px; font-weight: 600; line-height: 24px">{{ scope.row.cardPatientName }} </span>
                                    <span style="font-size: 14px; color:#aaa; line-height: 24px">{{ scope.row.sexText }}  {{ scope.row.age }}岁</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约人手机号">
                        <template #default="scope">
                            <span>{{ scope.row.cardPatientPhone === null ? '---' : scope.row.cardPatientPhone }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约人身份证">
                        <template #default="scope">
                            <span>{{ scope.row.cardIdentity === null ? '---' : scope.row.cardIdentity }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约时间"
                        width="260">
                        <template #default="scope">
                            <span style="font-size: 14px; font-weight: 600">{{ scope.row.reTime === null ? '---' : scope.row.reTime }} {{scope.row.reTimeTypeText}}{{ (scope.row.queueSeq || scope.row.reNo) ? (scope.row.queueSeq || scope.row.reNo) + '号' : '' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约单类型"
                        width="120">
                        <template #default="scope">
                            <el-tag :type="scope.row.visitType === null || scope.row.visitType === '初诊'?'success':'warning'" disable-transitions>
                                {{ scope.row.visitType === null ? '初诊': scope.row.visitType }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约单状态"
                        width="120">
                        <template #default="scope">
                            <el-tag
                                :type="scope.row.reStatus === '5' ? 'success' : scope.row.reStatus === '6' ? '' :
                                scope.row.reStatus === '7' ? 'danger' : scope.row.reStatus === '8' ? 'warning' :
                                scope.row.reStatus === '4' ? 'info' : scope.row.reStatus === '3' ? 'danger' :
                                scope.row.reStatus === '1' ? 'danger' : ''"
                                disable-transitions>{{ scope.row.reStatusText }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约医生">
                        <template #default="scope">
                            <span>{{ scope.row.doctorName === null ? '---' : scope.row.doctorName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="门诊科室">
                        <template #default="scope">
                            <span>{{ scope.row.odName === null ? '---' : scope.row.odName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="createTime"
                        label="创建时间">
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        label="操作"
                        width="200">
                        <template #default="scope">
                            <el-button type="warning" size="small" @click="handleSign(scope.row)" v-if="scope.row.reStatus === '8'">签到</el-button>
                            <el-button type="success" size="small" v-on:click="openMedical(scope.row)" v-if="scope.row.reStatus === '5'">接诊</el-button>
                            <el-button type="info" size="small" disabled v-if="scope.row.reStatus !== '5' && scope.row.reStatus !== '8'">接诊</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页-->
            <div class="table_pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-size="pageNums"
                    layout="prev, pager, next, total, sizes"
                    :total="totalCount">
                </el-pagination>
            </div>

        </div>
    </div>

</template>

<script>
import reservation from "@/assets/scripts/reservation/index";

export default reservation;
</script>

<style scoped>

</style>